import { useStyles } from './styles'
import { ProfileOverview } from '@/features/profileTabs/overview'
import { AppButton } from '../../shared/ui/button'
import { goToMain } from '@/app/routing/events'

import {
  $gigiBalance,
  // $isFirstSteamLogin,
  $userLanguage,
  $userToken,
  // setIsFirstLogin,
} from '@/entities/user'
import { $steamUserData } from '@/entities/platforms/steam/store'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { usePostStory } from '@/shared/hooks/usePostStory'
import ButtonWrapper from '../../shared/ui/buttonWrapper'

import { ProfileCard } from '@/features/unifiedProfileCard'
import { UpdateProgressButton } from '@/features/updateProgressButtons'
import { GamesList } from '@/features/profileTabs/gameList'
import { BackgroundShading } from '@/shared/ui/backgroundShading'
import { useMemo } from 'react'
import AppLoading from '@/features/loading'
import { getUserProfileFx } from '@/entities/user'
import { useBackButton } from '@/shared/hooks/useBackButton'
import useGetRefreshingStatus from '@/shared/hooks/useGetRefreshingStatus'
import { usePolling } from '@/shared/hooks/usePolling'

export const ProfileView = () => {
  useHideNav()
  const userToken = useUnit($userToken)
  // const isFirstLogin = useUnit($isFirstSteamLogin)
  useBackButton({ forceHide: false })
  const { isSteamRefreshing } = useGetRefreshingStatus()

  // useEffect(() => {
  //   if (isFirstLogin) {
  //     setIsFirstLogin(false)
  //     setTimeout(() => setIsLoading(false), 3000)
  //   } else {
  //     setIsLoading(false)
  //   }
  // }, [isFirstLogin])

  const { classes } = useStyles()

  const steamUserData = useUnit($steamUserData)

  const userLang = useUnit($userLanguage)
  const gigiBalance = useUnit($gigiBalance)
  const texts = lang[userLang].pages.profile
  const btnTexts = lang[userLang].pages.btnTexts
  const { canShareStory, isMakingStoryLink, handleShareStory } = usePostStory()

  const selectedGames = useMemo(() => {
    if (!steamUserData) return []
    const sorted = steamUserData.gamesList
      ?.filter((game) => game.total_hours > 0)
      .sort((a, b) => b.total_hours - a.total_hours)
    return sorted?.slice(0, 5) ?? []
  }, [steamUserData])

  usePolling(
    () => {
      if (!userToken) return
      getUserProfileFx(userToken)
    },
    1000,
    !!userToken && isSteamRefreshing
  )

  // useEffect(() => {
  //   if (!userToken) return

  //   if (!steamUserData?.userData) {
  //     const fetchData = () => {
  //       getUserProfileFx(userToken)
  //     }

  //     fetchData()

  //     const intervalId = setInterval(() => {
  //       if (steamUserData?.userData.steam_update_in_progress) {
  //         fetchData()
  //       } else {
  //         clearInterval(intervalId)
  //       }
  //     }, 3000)

  //     return () => clearInterval(intervalId)
  //   }
  // }, [userToken, steamUserData?.userData])

  if (!steamUserData?.userData || isSteamRefreshing) return <AppLoading />
  const userData = steamUserData.userData

  return (
    <div
      id="profileScreen"
      className={classes.root}
    >
      <div className={classes.backgroundContainer}>
        <p className={classes.status}>{`◉ Steam ${texts.status}`}</p>
        <BackgroundShading
          top="170px"
          zIndex={3}
        />
      </div>
      <div className={classes.contentContainer}>
        <ProfileCard balance={gigiBalance} />

        <UpdateProgressButton />
        <div className={classes.textsWrapper}>
          <span className={classes.sectionHeadingText}>{texts.gamingLegacy}</span>
        </div>
        <ProfileOverview userData={userData} />
        <span className={classes.sectionHeadingText}>{texts.favoriteGames}</span>
        <GamesList gamesList={selectedGames} />
      </div>
      <ButtonWrapper
        startColor="#00000000"
        endColor="#FFFFFF10"
        style={{
          paddingLeft: '5%',
          paddingRight: '5%',
        }}
      >
        <AppButton
          variant="primary"
          size="large"
          fullWidth={true}
          style={{ height: '52px' }}
          onClick={() => goToMain()}
        >
          {btnTexts.time}
        </AppButton>
        <AppButton
          style={{ height: '52px' }}
          variant="storiesReward"
          fullWidth={true}
          isLoading={isMakingStoryLink}
          disabled={!canShareStory}
          onClick={handleShareStory}
        >
          {btnTexts.share}
        </AppButton>
      </ButtonWrapper>
    </div>
  )
}
